import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierRM-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import RMPolicyChangesPage from './pages/RMPolicyChanges/RMPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierRMPolicyChangesPage: { component: 'PremierRMPolicyChangesPage' }
    },
    {
        PremierRMPolicyChangesPage: RMPolicyChangesPage
    }
);

export { default as PremierRMPolicyChangeWizard } from './PremierRMPolicyChangeWizard';
